(function () {
  "use strict";

  angular
    .module('trainerWebApp.directives')
    .directive('mfYammerTrainees', mfYammerTrainees);

  function mfYammerTrainees() {
    return {
      restrict: 'A',
      link: function ($scope, iElement, iAttrs) {
        iElement.find('.yammer-select2-input').bind('change select2-open select2-close', function (e) {
          // Make the grid resize.
          $('#yammerUsersGrid').trigger('resize');
        });
      }
    }
  }

})();
